/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Measure_Explainer_Step_CapInputs */

const en_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} cap`)
};

const zh_hans1_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount}（封顶）`)
};

const pt_br2_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} (teto)`)
};

const es_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tope de ${i?.amount}`)
};

const fr_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`plafond de ${i?.amount}`)
};

const de_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} Obergrenze`)
};

const ru_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Лимит ${i?.amount}`)
};

const it_measure_explainer_step_cap = /** @type {(inputs: Measure_Explainer_Step_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tetto di ${i?.amount}`)
};

/**
* | output |
* | --- |
* | "{amount} cap" |
*
* @param {Measure_Explainer_Step_CapInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_step_cap = /** @type {((inputs: Measure_Explainer_Step_CapInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Explainer_Step_CapInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_explainer_step_cap(inputs)
	if (locale === "pt-BR") return pt_br2_measure_explainer_step_cap(inputs)
	if (locale === "es") return es_measure_explainer_step_cap(inputs)
	if (locale === "fr") return fr_measure_explainer_step_cap(inputs)
	if (locale === "de") return de_measure_explainer_step_cap(inputs)
	if (locale === "ru") return ru_measure_explainer_step_cap(inputs)
	if (locale === "it") return it_measure_explainer_step_cap(inputs)
	return en_measure_explainer_step_cap(inputs)
});